/* TallyPage toasts: one call site for the look. "Title – detail" messages split into a bold title + quieter line. */
import { toast } from "sonner";

const SPLIT = /\s[–—]\s/;
const wrap = (fn) => (msg, opts) => {
  if (typeof msg === "string" && !(opts && opts.description)) {
    const m = msg.match(SPLIT);
    if (m && m.index > 2 && m.index < 90) return fn(msg.slice(0, m.index), { ...(opts || {}), description: msg.slice(m.index + m[0].length) });
  }
  return fn(msg, opts);
};

["success", "error", "info", "warning", "message", "loading"].forEach((k) => { if (typeof toast[k] === "function") toast[k] = wrap(toast[k]); });

export { toast };
